export { default } from "next-auth/middleware";

export const config = {
  matcher: [
    "/dashboard/:path*",
    "/plan/:path*",
    "/supplements/:path*",
    "/recipes/:path*",
    "/profile/:path*",
    "/onboarding",
  ],
};
